import { Component, createContext} from 'react';


export const DocumentsContext = createContext({
  categories: [],
  setCategories: (categories) => {},
});


export class DocumentsProvider extends Component {

  constructor(props) {
    super(props);
    this.state = {
      categories: [], // categories dict is used
      setCategories: this.setCategories,
    };
  }

  setCategories = (categories) => this.setState({categories});

  render() {
    return (
      <DocumentsContext.Provider value={this.state}>
        {this.props.children}
      </DocumentsContext.Provider>
    );
  }
}
